<template>
  <div class="products_page">
    <header-bar></header-bar>

    <!-- 页头横幅 -->
    <div class="prod_hero">
      <img
        class="prod_hero_bg"
        :src="require('@/assets/banner_neural.jpg')"
        alt="般意品牌蓝色神经网络背景"
      />
      <div class="prod_hero_mask"></div>
      <div class="prod_hero_content">
        <div class="prod_hero_title">产品中心</div>
        <div class="prod_hero_sub">三款消费级产品 + 二类医疗器械版，按需选择</div>
      </div>
    </div>

    <!-- 产品对比 -->
    <div class="prod_section prod_white">
      <div class="section_title">产品对比</div>
      <div class="prod_grid">
        <div class="prod_card" v-for="product in products" :key="product.model">
          <div class="prod_art" :class="'prod_art_' + artOf(product.model).theme">
            <img
              v-if="artOf(product.model).src"
              :class="
                artOf(product.model).mode === 'cover'
                  ? 'prod_art_cover'
                  : 'prod_art_contain'
              "
              :src="artOf(product.model).src"
              :alt="product.model + ' ' + product.nickname"
            />
            <div v-else class="prod_art_fallback">{{ product.model }}</div>
          </div>
          <div class="prod_body">
            <div class="prod_head">
              <div class="prod_model">{{ product.model }}</div>
              <div
                class="prod_nickname"
                :class="'prod_nickname_' + artOf(product.model).theme"
              >
                {{ product.nickname }}
              </div>
            </div>
            <div class="prod_row">
              <div class="prod_label">定位</div>
              <div class="prod_value">{{ product.position }}</div>
            </div>
            <div class="prod_row">
              <div class="prod_label">适合谁</div>
              <div class="prod_value">{{ product.forWhom }}</div>
            </div>
            <div class="prod_row">
              <div class="prod_label">价格带</div>
              <div class="prod_value">{{ product.priceBand }}</div>
            </div>
            <div class="prod_btns">
              <router-link
                v-if="product.route"
                class="prod_btn_primary"
                :class="'prod_btn_' + artOf(product.model).theme"
                :to="product.route"
                >产品详情 →</router-link
              >
              <a
                class="prod_btn_ghost"
                :href="product.buyUrl || purchase.tmallFullUrl"
                target="_blank"
                rel="noopener noreferrer"
                >去{{ product.buyUrl ? "京东" : "天猫官方旗舰店" }}了解</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选购建议 -->
    <div class="prod_section prod_gray">
      <div class="section_title">选购建议</div>
      <div class="guide_list">
        <div class="guide_item guide_gold">
          <span class="guide_need">情绪与睡眠</span>
          <span class="guide_arrow">→</span>
          <span class="guide_prod">LOTUS 2 金色能量版</span>
        </div>
        <div class="guide_item guide_blue">
          <span class="guide_need">专注与记忆</span>
          <span class="guide_arrow">→</span>
          <span class="guide_prod">LOTUS 2R 蓝色认知版</span>
        </div>
        <div class="guide_item guide_purple">
          <span class="guide_need">睡眠节律</span>
          <span class="guide_arrow">→</span>
          <span class="guide_prod">Lume 光能睡眠仪</span>
        </div>
      </div>
      <div class="guide_help">
        不确定怎么选？去
        <router-link class="guide_link" to="/support">支持页</router-link>
        看常见问题，或拨打 {{ contact.phone }} 咨询。
      </div>
    </div>

    <!-- 安心承诺条 -->
    <div class="promise_bar">
      <div class="promise_items">
        <div
          class="promise_item"
          v-for="(item, index) in purchase.afterSale"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="promise_antifake">{{ purchase.antiFake }}</div>
    </div>

    <footer-info></footer-info>
  </div>
</template>

<script>
import headerBar from "@/components/common/HeaderBar";
import footerInfo from "@/components/common/FooterInfo";
import { products, purchase, contact } from "@/data/facts";

export default {
  name: "Products",
  data() {
    return {
      products,
      purchase,
      contact,
      // 产品配图与主题色（老站视觉资产：金 = LOTUS 2，蓝 = LOTUS 2R，品牌蓝紫 = Lume）
      productArt: {
        "LOTUS 2": {
          theme: "gold",
          mode: "cover",
          src:
            require("@/assets/product_lotus2_hero.jpg"),
        },
        "LOTUS 2R": {
          theme: "blue",
          mode: "cover",
          src:
            require("@/assets/product_lotus2r_hero.jpg"),
        },
        Lume: {
          theme: "purple",
          mode: "cover",
          src: require("@/assets/lume_product.png"),
        },
        经颅直流电刺激仪: {
          theme: "blue",
          mode: "contain",
          src: require("@/assets/headband_white.png"),
        },
      },
    };
  },
  methods: {
    artOf(model) {
      return (
        this.productArt[model] || { theme: "gray", mode: "contain", src: "" }
      );
    },
  },
  components: {
    headerBar,
    footerInfo,
  },
};
</script>

<style scoped>
.products_page {
  width: 100vw;
  background: #ffffff;
}

/* 页头横幅 */
.prod_hero {
  position: relative;
  width: 100vw;
  height: 26vw;
  overflow: hidden;
}

.prod_hero_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.prod_hero_mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(10, 12, 60, 0.6) 0%,
    rgba(27, 30, 138, 0.28) 60%,
    rgba(27, 30, 138, 0.12) 100%
  );
}

.prod_hero_content {
  position: relative;
  padding: 8.6vw 13.3vw 0 13.3vw;
}

.prod_hero_title {
  color: #ffffff;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.5vw;
}

.prod_hero_sub {
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.25vw;
  margin-top: 1.3vw;
}

/* 通用区块 */
.prod_section {
  padding: 4.2vw 13.3vw;
}

.prod_white {
  background: #ffffff;
}

.prod_gray {
  background: #f7f8fa;
}

.section_title {
  text-align: center;
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.5vw;
  margin-bottom: 3.6vw;
}

/* 产品对比 */
.prod_grid {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.prod_card {
  display: flex;
  flex-direction: column;
  width: 22vw;
  margin: 0 0.9vw;
  background: #ffffff;
  border: 1px solid #e8e9f5;
  border-radius: 1.04vw;
  overflow: hidden;
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.05);
}

.prod_card:hover {
  box-shadow: 0 0.6vw 2.2vw rgba(27, 30, 138, 0.14);
}

.prod_art {
  width: 100%;
  height: 14vw;
  overflow: hidden;
}

.prod_art_purple {
  background: linear-gradient(135deg, #1b1e8a 0%, #888ef9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.prod_art_cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.prod_art_contain {
  width: 60%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.prod_art_gray {
  background: linear-gradient(135deg, #4a4f6b 0%, #9aa0c3 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.prod_art_fallback {
  font-family: "SourceHanSansCN-Bold", sans-serif;
  font-size: 2vw;
  color: #ffffff;
  letter-spacing: 0.2vw;
  text-align: center;
}

.prod_art_gold,
.prod_art_blue {
  display: flex;
  align-items: center;
  justify-content: center;
}

.prod_art_blue {
  background: linear-gradient(96deg, #eef1fa 0%, #d9e0f2 100%);
}

.prod_body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1.8vw 1.8vw 2.2vw 1.8vw;
}

.prod_head {
  text-align: center;
  padding-bottom: 1.6vw;
  border-bottom: 1px solid #f0f0f0;
}

.prod_model {
  color: #1b1e8a;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.7vw;
}

.prod_nickname {
  display: inline-block;
  margin-top: 0.8vw;
  background: rgba(136, 142, 249, 0.14);
  color: #888ef9;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 0.94vw;
  padding: 0.3vw 1.2vw;
  border-radius: 1.5vw;
}

.prod_nickname_gold {
  background: rgba(181, 136, 100, 0.14);
  color: #a87e5f;
}

.prod_nickname_blue {
  background: rgba(107, 124, 181, 0.14);
  color: #6b7cb5;
}

.prod_row {
  margin-top: 1.3vw;
}

.prod_label {
  color: #9b9b9b;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.94vw;
}

.prod_value {
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 1vw;
  line-height: 1.7;
  margin-top: 0.4vw;
}

.prod_btns {
  margin-top: auto;
  padding-top: 1.8vw;
}

.prod_btn_primary {
  display: block;
  background: #1b1e8a;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1vw;
  padding: 0.75vw 0;
  border-radius: 0.5vw;
  text-decoration: none;
}

.prod_btn_gold {
  background: #b58864;
}

.prod_btn_blue {
  background: #6b7cb5;
}

.prod_btn_purple {
  background: #888ef9;
}

.prod_btn_ghost {
  display: block;
  margin-top: 0.8vw;
  border: 1px solid #1b1e8a;
  color: #1b1e8a;
  text-align: center;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1vw;
  padding: 0.75vw 0;
  border-radius: 0.5vw;
  text-decoration: none;
}

/* 选购建议 */
.guide_list {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.guide_item {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 0.83vw;
  padding: 1.5vw 1.8vw;
  margin: 0 0.9vw;
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.05);
  border-left: 0.35vw solid transparent;
}

.guide_gold {
  border-left-color: #c79a53;
}

.guide_blue {
  border-left-color: #6b7cb5;
}

.guide_purple {
  border-left-color: #888ef9;
}

.guide_need {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.04vw;
}

.guide_arrow {
  color: #888ef9;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.04vw;
  margin: 0 0.9vw;
}

.guide_prod {
  color: #1b1e8a;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.04vw;
}

.guide_help {
  text-align: center;
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 1.04vw;
  margin-top: 2.6vw;
}

.guide_link {
  color: #1b1e8a;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  text-decoration: none;
}

/* 安心承诺条 */
.promise_bar {
  background: linear-gradient(90deg, #1b1e8a 0%, #2b2fa8 60%, #888ef9 130%);
  text-align: center;
  padding: 3vw 13.3vw 3.2vw 13.3vw;
}

.promise_items {
  display: flex;
  justify-content: center;
  align-items: center;
}

.promise_item {
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.15vw;
  padding: 0 3vw;
  border-right: 1px solid rgba(255, 255, 255, 0.25);
}

.promise_item:last-child {
  border-right: none;
}

.promise_antifake {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9vw;
  margin-top: 1.6vw;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Products.vue